(function () {
  'use strict';

  var state = {
    motivOn: true,
    selectedIcon: null,
    selectedBg: null,
    selectedFont: null,
    selectedFontWeight: '700',
    selectedColor: '#000000',
    selectedVariantId: null
  };

  var twoChildren = {
    active: false,
    editingChild: 1,
    designs: { 1: null, 2: null },
    child2Visited: false
  };

  var gridCarousels = {};
  var iconData = [];
  var renderedIconPages = {};

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  /* ----------------------------------------------------------------
     Icon Grid – build from JSON, render only visible page
     ---------------------------------------------------------------- */
  function loadIconData() {
    var el = q('#sk-icons-data');
    if (!el) return;
    try { iconData = JSON.parse(el.textContent); } catch (e) { iconData = []; }
  }

  function buildIconGrid() {
    var grid = q('#sk-icon-grid');
    if (!grid || !iconData.length) return;

    var cols = parseInt(grid.getAttribute('data-cols'), 10) || 8;
    var rows = parseInt(grid.getAttribute('data-rows'), 10) || 3;
    var perPage = cols * rows;

    for (var i = 0; i < iconData.length; i++) {
      var d = iconData[i];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sk-grid-item sk-icon-item' + (i === 0 ? ' sk-selected' : '');
      btn.setAttribute('data-name', d.n);
      btn.setAttribute('data-label', d.l);
      btn.setAttribute('data-url', d.u);
      btn.setAttribute('data-category', d.c);
      btn.setAttribute('aria-label', d.l);
      btn.setAttribute('data-icon-index', i);

      var span = document.createElement('span');
      span.className = 'sk-icon-circle';

      if (i < perPage) {
        var img = document.createElement('img');
        img.alt = d.l;
        img.loading = 'lazy';
        img.width = 86;
        img.height = 86;
        img.src = d.u;
        attachBrokenHandler(img);
        span.appendChild(img);
      }

      btn.appendChild(span);

      if (i >= perPage) {
        btn.classList.add('sk-page-hidden');
      }

      grid.appendChild(btn);
    }

    renderedIconPages[0] = true;
  }

  function ensureIconImagesForPage(pageNum, carousel) {
    if (renderedIconPages[pageNum]) return;
    renderedIconPages[pageNum] = true;

    var start = pageNum * carousel.perPage;
    var end = start + carousel.perPage;
    var items = qa('.sk-icon-item', carousel.grid);
    var visIdx = 0;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.classList.contains('sk-filter-hidden') || item.hasAttribute('data-broken')) continue;
      if (visIdx >= start && visIdx < end) {
        var circle = item.querySelector('.sk-icon-circle');
        if (circle && !circle.querySelector('img')) {
          var idx = parseInt(item.getAttribute('data-icon-index'), 10);
          if (!isNaN(idx) && iconData[idx]) {
            var img = document.createElement('img');
            img.alt = iconData[idx].l;
            img.loading = 'lazy';
            img.width = 86;
            img.height = 86;
            img.src = iconData[idx].u;
            attachBrokenHandler(img);
            circle.appendChild(img);
          }
        }
      }
      visIdx++;
    }
  }

  /* ----------------------------------------------------------------
     Background SVG lazy loading
     ---------------------------------------------------------------- */
  function lazyLoadVisibleBgImages(carousel) {
    if (!carousel || carousel.grid.id !== 'sk-bg-grid') return;
    var items = qa('.sk-bg-item:not(.sk-page-hidden):not([data-broken])', carousel.grid);
    items.forEach(function (item) {
      var circle = item.querySelector('.sk-bg-circle[data-bg-url]');
      if (circle && !circle.style.backgroundImage) {
        circle.style.backgroundImage = "url('" + circle.getAttribute('data-bg-url') + "')";
      }
    });
  }

  function ensureBgImagesForPage(page, carousel) {
    if (!carousel || carousel.grid.id !== 'sk-bg-grid') return;
    var filteredItems = getFilteredItems(carousel);
    var start = page * carousel.perPage;
    var end = Math.min(start + carousel.perPage, filteredItems.length);
    for (var i = start; i < end; i++) {
      var circle = filteredItems[i].querySelector('.sk-bg-circle[data-bg-url]');
      if (circle && !circle.style.backgroundImage) {
        circle.style.backgroundImage = "url('" + circle.getAttribute('data-bg-url') + "')";
      }
    }
  }

  function updateStickyTop() {
    var konfigurator = document.getElementById('sticker-konfigurator');
    if (!konfigurator) return;
    var body = document.body;
    var offset = 0;
    if (body.classList.contains('sticky-header')) {
      var headerEl = document.querySelector('.header-section');
      if (headerEl) offset += headerEl.getBoundingClientRect().height;
    }
    if (body.classList.contains('sticky-announcement_bar')) {
      var announcementEl = document.querySelector('.announcement-section');
      if (announcementEl) offset += announcementEl.getBoundingClientRect().height;
    }
    konfigurator.style.setProperty('--sk-sticky-top', (offset + 12) + 'px');
  }

  function initMobileLayout() {
    var MOBILE_BP = 1000;
    if (window.innerWidth >= MOBILE_BP) return;

    var rightCol    = document.getElementById('sk-right-col');
    var previewSlot = document.getElementById('sk-mobile-preview-slot');
    var cartSlot    = document.getElementById('sk-mobile-cart-slot');

    if (previewSlot) {
      var previewContainer = document.querySelector('.sk-preview-container');
      if (previewContainer && previewSlot.parentNode) {
        previewSlot.parentNode.insertBefore(previewContainer, previewSlot);
      }
    }

    if (cartSlot) {
      var variantsEl = document.getElementById('sk-variants');
      var cartGroup  = document.getElementById('sk-cart-group');
      if (variantsEl) cartSlot.appendChild(variantsEl);
      if (cartGroup)  cartSlot.appendChild(cartGroup);

      var trustBar = document.getElementById('sk-trust-bar');
      if (trustBar) cartSlot.appendChild(trustBar);
    }

    if (rightCol) rightCol.style.display = 'none';
  }

  /* ----------------------------------------------------------------
     Mobile keyboard – keep sticker preview visible when keyboard opens.
     The preview stays position:sticky so it is always visible while the
     user scrolls through motifs, backgrounds, fonts and colours.  We
     only compact its size and correct the scroll position so the
     browser's auto-scroll-to-input doesn't push the preview off-screen.
     ---------------------------------------------------------------- */
  function initMobileKeyboardHandler() {
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var konfigurator = q('#sticker-konfigurator');
    var inputs = qa('.sk-input');
    var previewContainer = q('.sk-preview-container');
    if (!konfigurator || !inputs.length || !previewContainer) return;

    var keyboardOpen = false;
    var scrollTimers = [];

    function clearScrollTimers() {
      scrollTimers.forEach(function (id) { clearTimeout(id); });
      scrollTimers = [];
    }

    function scrollPreviewIntoView() {
      var rect = previewContainer.getBoundingClientRect();
      var stickyTop = parseFloat(getComputedStyle(konfigurator).getPropertyValue('--sk-sticky-top')) || 12;
      if (rect.top < stickyTop) {
        window.scrollBy({ top: rect.top - stickyTop - 4, behavior: 'smooth' });
      }
    }

    function onInputFocus() {
      if (!mobileQuery.matches) return;
      keyboardOpen = true;
      konfigurator.classList.add('sk-keyboard-open');
      updatePreview();

      clearScrollTimers();
      scrollTimers.push(setTimeout(scrollPreviewIntoView, 350));
      scrollTimers.push(setTimeout(scrollPreviewIntoView, 600));
    }

    function onInputBlur() {
      clearScrollTimers();
      scrollTimers.push(setTimeout(function () {
        var active = document.activeElement;
        if (active && active.classList && active.classList.contains('sk-input')) return;
        keyboardOpen = false;
        konfigurator.classList.remove('sk-keyboard-open');
        updatePreview();
      }, 200));
    }

    inputs.forEach(function (input) {
      input.addEventListener('focus', onInputFocus);
      input.addEventListener('blur', onInputBlur);
    });

    var scrollBlurStartY = null;
    document.addEventListener('touchstart', function (e) {
      var ae = document.activeElement;
      if (ae && ae.classList && ae.classList.contains('sk-input') && mobileQuery.matches) {
        var target = e.target;
        if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.closest('.sk-input-wrap'))) {
          scrollBlurStartY = null;
          return;
        }
        scrollBlurStartY = e.changedTouches[0].clientY;
      } else {
        scrollBlurStartY = null;
      }
    }, { passive: true });

    document.addEventListener('touchmove', function (e) {
      if (scrollBlurStartY !== null) {
        var dy = Math.abs(e.changedTouches[0].clientY - scrollBlurStartY);
        if (dy > 10) {
          var ae = document.activeElement;
          if (ae && ae.classList && ae.classList.contains('sk-input')) {
            ae.blur();
          }
          scrollBlurStartY = null;
        }
      }
    }, { passive: true });

    if (window.visualViewport) {
      var baseHeight = window.visualViewport.height;
      var vpScrollTimer = null;
      window.visualViewport.addEventListener('resize', function () {
        if (!mobileQuery.matches) return;
        var diff = baseHeight - window.visualViewport.height;

        if (diff > 150 && keyboardOpen) {
          if (vpScrollTimer) clearTimeout(vpScrollTimer);
          vpScrollTimer = setTimeout(scrollPreviewIntoView, 120);
        }

        var ae = document.activeElement;
        if (diff < 100 && !(ae && ae.classList && ae.classList.contains('sk-input'))) {
          keyboardOpen = false;
          konfigurator.classList.remove('sk-keyboard-open');
          updatePreview();
        }
      });
    }
  }

  function init() {
    if (!q('#sticker-konfigurator')) return;

    updateStickyTop();
    initMobileLayout();

    loadIconData();
    buildIconGrid();

    /* Background images are loaded lazily per page via lazyLoadVisibleBgImages
       and ensureBgImagesForPage – no eager bulk load needed */

    initCharCounters();
    initMotivToggle();
    initBrokenImageHandler();
    initBrokenBgHandler();
    initIconGrid();
    initBgGrid();
    initFontGrid();
    initColorGrid();
    initVariants();
    initTwoChildren();
    initQuantity();
    initFormValidation();
    initFilters();
    initGridCarousels();
    initProductCarousel();
    initAccordions();
    initMobileKeyboardHandler();
    handleResponsivePreview();
    initStickyStop();
    updatePreview();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { updatePreview(); });
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        updateStickyTop();
        handleResponsivePreview();
        recalcStabilizedGridMinHeightsOnResize();
      }, 150);
    });
  }

  function initCharCounters() {
    qa('.sk-input').forEach(function (input) {
      var line = input.getAttribute('data-line');
      var counter = q('.sk-count[data-count-for="' + line + '"]');
      input.addEventListener('input', function () {
        if (counter) counter.textContent = input.value.length;
        q('#sk-error-msg').classList.remove('sk-visible');
        input.classList.remove('sk-error');
        syncProperties();
        updatePreview();
      });
    });
  }

  function initMotivToggle() {
    var toggle = q('#sk-motiv-toggle');
    if (!toggle) return;
    toggle.addEventListener('change', function () {
      state.motivOn = toggle.checked;
      var carousel = q('#sk-icon-carousel');
      if (carousel) carousel.classList.toggle('sk-disabled', !state.motivOn);
      var dots = q('#sk-icon-dots');
      if (dots) dots.style.opacity = state.motivOn ? '' : '0.35';
      syncProperties();
      updatePreview();
    });
  }

  function attachBrokenHandler(img) {
    img.addEventListener('error', function () {
      var item = img.closest('.sk-icon-item');
      if (!item || item.hasAttribute('data-broken')) return;
      item.setAttribute('data-broken', 'true');
      item.style.display = 'none';

      if (item.classList.contains('sk-selected')) {
        item.classList.remove('sk-selected');
        var next = qa('.sk-icon-item:not([data-broken])')[0];
        if (next) {
          next.classList.add('sk-selected');
          state.selectedIcon = { url: next.getAttribute('data-url'), label: next.getAttribute('data-label') };
          syncProperties();
          updatePreview();
        }
      }

      recalcGridCarousel('sk-icon-grid');
    });

    if (img.complete && img.naturalWidth === 0 && img.src) {
      img.dispatchEvent(new Event('error'));
    }
  }

  function initBrokenImageHandler() {
    qa('.sk-icon-item img').forEach(function (img) {
      attachBrokenHandler(img);
    });
  }

  function initBrokenBgHandler() {
    qa('.sk-bg-item').forEach(function (item) {
      var url = item.getAttribute('data-url');
      if (!url) {
        markBgBroken(item);
        return;
      }
      var testImg = new Image();
      testImg.addEventListener('error', function () {
        markBgBroken(item);
      });
      testImg.src = url;
    });
  }

  function markBgBroken(item) {
    if (item.hasAttribute('data-broken')) return;
    item.setAttribute('data-broken', 'true');
    item.style.display = 'none';

    if (item.classList.contains('sk-selected')) {
      item.classList.remove('sk-selected');
      var next = qa('.sk-bg-item:not([data-broken])')[0];
      if (next) {
        next.classList.add('sk-selected');
        state.selectedBg = { url: next.getAttribute('data-url'), label: next.getAttribute('data-label') };
        syncProperties();
        updatePreview();
      }
    }

    recalcGridCarousel('sk-bg-grid');
  }

  /* ----------------------------------------------------------------
     Grid Carousels – paginated grids with arrow navigation
     ---------------------------------------------------------------- */
  function initGridCarousels() {
    qa('.sk-grid-carousel').forEach(function (wrapper) {
      var grid = wrapper.querySelector('[data-cols]');
      if (!grid) return;

      var cols = parseInt(grid.getAttribute('data-cols'), 10) || 8;
      var rows = parseInt(grid.getAttribute('data-rows'), 10) || 3;
      var perPage = cols * rows;
      var gridId = grid.id;

      var dotsContainer = null;
      var next = wrapper.nextElementSibling;
      if (next && next.classList.contains('sk-grid-dots')) dotsContainer = next;

      var prevBtn = wrapper.querySelector('.sk-grid-prev');
      var nextBtn = wrapper.querySelector('.sk-grid-next');

      var carousel = {
        wrapper: wrapper,
        grid: grid,
        cols: cols,
        rows: rows,
        perPage: perPage,
        currentPage: 0,
        prevBtn: prevBtn,
        nextBtn: nextBtn,
        dotsContainer: dotsContainer
      };

      gridCarousels[gridId] = carousel;

      if (prevBtn) prevBtn.addEventListener('click', function () {
        goGridPage(carousel, carousel.currentPage - 1);
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        goGridPage(carousel, carousel.currentPage + 1);
      });

      var viewport = grid.parentElement;

      var touchStartX   = null;
      var touchDragging = false;
      var touchAnimating = false;
      var ghost         = null;
      var ghostDir      = 0;
      var lastVelocity  = 0;
      var lastTouchX    = 0;
      var lastTouchTime = 0;
      var rafId         = null;
      var pendingDx     = 0;

      /* Build a visual-only clone of the target page's items */
      function buildGhost(targetPage) {
        var total = getTotalPages(carousel);
        targetPage = ((targetPage % total) + total) % total;
        var filteredItems = getFilteredItems(carousel);
        var start = targetPage * carousel.perPage;
        var end   = Math.min(start + carousel.perPage, filteredItems.length);

        var g = document.createElement('div');
        g.className = grid.className + ' sk-swipe-ghost';
        g.setAttribute('aria-hidden', 'true');
        try { g.inert = true; } catch (e) {}

        for (var j = start; j < end; j++) {
          var clone = filteredItems[j].cloneNode(true);
          clone.classList.remove('sk-page-hidden', 'sk-selected');
          clone.tabIndex = -1;
          var bgCircle = clone.querySelector('.sk-bg-circle[data-bg-url]');
          if (bgCircle && !bgCircle.style.backgroundImage) {
            bgCircle.style.backgroundImage = "url('" + bgCircle.getAttribute('data-bg-url') + "')";
          }
          g.appendChild(clone);
        }
        return g;
      }

      function attachGhost(direction) {
        if (ghost) return;
        var total = getTotalPages(carousel);
        if (total <= 1) return;
        ghostDir = direction;
        var vw = viewport.offsetWidth;
        var targetPage = (((carousel.currentPage + direction) % total) + total) % total;
        ghost = buildGhost(targetPage);
        ghost.style.cssText = 'position:absolute;top:0;width:' + vw + 'px;pointer-events:none;' +
                              'left:' + (direction === 1 ? vw : -vw) + 'px;';
        viewport.appendChild(ghost);
      }

      function removeGhost() {
        if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
        ghost = null;
        ghostDir = 0;
      }

      function applyDrag(dx) {
        var t = 'translate3d(' + dx + 'px,0,0)';
        grid.style.transform  = t;
        if (ghost) ghost.style.transform = t;
      }

      wrapper.addEventListener('touchstart', function (e) {
        if (touchAnimating) return;
        touchStartX    = e.changedTouches[0].clientX;
        touchDragging  = false;
        lastVelocity   = 0;
        lastTouchX     = touchStartX;
        lastTouchTime  = Date.now();
        grid.style.transition = 'none';
        grid.style.transform  = 'translate3d(0,0,0)';

        /* Kick off image preloading for adjacent pages immediately */
        if (gridId === 'sk-icon-grid') {
          var tot = getTotalPages(carousel);
          ensureIconImagesForPage((carousel.currentPage + 1) % tot, carousel);
          ensureIconImagesForPage(((carousel.currentPage - 1) % tot + tot) % tot, carousel);
        }
        if (gridId === 'sk-bg-grid') {
          var tot2 = getTotalPages(carousel);
          ensureBgImagesForPage((carousel.currentPage + 1) % tot2, carousel);
          ensureBgImagesForPage(((carousel.currentPage - 1) % tot2 + tot2) % tot2, carousel);
        }
      }, { passive: true });

      wrapper.addEventListener('touchmove', function (e) {
        if (touchStartX === null || touchAnimating) return;
        var now    = Date.now();
        var touchX = e.changedTouches[0].clientX;
        var dx     = touchX - touchStartX;
        var dt     = now - lastTouchTime;
        if (dt > 0) lastVelocity = (touchX - lastTouchX) / dt;
        lastTouchX    = touchX;
        lastTouchTime = now;

        if (!touchDragging && Math.abs(dx) > 6) {
          touchDragging = true;
          attachGhost(dx > 0 ? -1 : 1);
        }
        if (touchDragging) {
          pendingDx = dx;
          if (!rafId) {
            rafId = requestAnimationFrame(function () {
              rafId = null;
              applyDrag(pendingDx);
            });
          }
        }
      }, { passive: true });

      wrapper.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }

        if (!touchDragging) { removeGhost(); grid.style.transition = ''; grid.style.transform = ''; return; }
        touchDragging = false;

        var total    = getTotalPages(carousel);
        var vw       = viewport.offsetWidth;
        var commit   = total > 1 && ghost && (Math.abs(lastVelocity) > 0.3 || Math.abs(dx) >= 30);

        touchAnimating = true;
        var EASE = 'transform 0.22s cubic-bezier(0.25,0.46,0.45,0.94)';

        if (!commit) {
          /* Snap back */
          grid.style.transition = EASE;
          grid.style.transform  = 'translate3d(0,0,0)';
          if (ghost) { ghost.style.transition = EASE; ghost.style.transform = 'translate3d(0,0,0)'; }
          setTimeout(function () {
            removeGhost();
            grid.style.transition = '';
            grid.style.transform  = '';
            touchAnimating = false;
          }, 230);
          return;
        }

        /* Commit – slide out grid, slide in ghost */
        var direction = dx > 0 ? -1 : 1;
        var exitPx    = (-direction * vw) + 'px';
        var nextPage  = (((carousel.currentPage + direction) % total) + total) % total;

        grid.style.transition  = EASE;
        ghost.style.transition = EASE;
        grid.style.transform   = 'translate3d(' + exitPx + ',0,0)';
        ghost.style.transform  = 'translate3d(' + exitPx + ',0,0)';

        setTimeout(function () {
          carousel.currentPage = nextPage;

          /* Reset the real grid to its resting position first – no transition –
             so it is already at position 0 when the ghost is removed.
             This eliminates the one-frame jump that caused the mini-snap. */
          grid.style.transition = 'none';
          grid.style.transform  = '';
          void grid.offsetWidth; // flush layout so the reset is committed

          renderGridPage(carousel);

          /* Remove ghost – real grid is already in place */
          removeGhost();

          touchAnimating = false;
        }, 230);
      }, { passive: true });

      wrapper.addEventListener('touchcancel', function () {
        touchStartX = null;
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        touchDragging = false;
        if (!touchAnimating) {
          removeGhost();
          grid.style.transition = '';
          grid.style.transform  = '';
        }
      }, { passive: true });

      renderGridPage(carousel);

      if (gridId === 'sk-bg-grid') {
        lazyLoadVisibleBgImages(carousel);
      }
      if (shouldStabilizeGridViewport(carousel)) {
        recalcGridViewportMinHeightMax(carousel);
      }
    });
  }

  function getFilteredItems(carousel) {
    var all = qa(':scope > button', carousel.grid);
    return all.filter(function (item) {
      return !item.classList.contains('sk-filter-hidden') && !item.hasAttribute('data-broken');
    });
  }

  function getTotalPages(carousel) {
    var items = getFilteredItems(carousel);
    return Math.max(1, Math.ceil(items.length / carousel.perPage));
  }

  function goGridPage(carousel, page) {
    var total = getTotalPages(carousel);
    carousel.currentPage = ((page % total) + total) % total;
    renderGridPage(carousel);

    if (carousel.grid.id === 'sk-icon-grid') {
      ensureIconImagesForPage(carousel.currentPage, carousel);
      preloadNeighborIconPages(carousel);
    }
    if (carousel.grid.id === 'sk-bg-grid') {
      lazyLoadVisibleBgImages(carousel);
      preloadNeighborBgPages(carousel);
    }
  }

  function preloadNeighborIconPages(carousel) {
    var total = getTotalPages(carousel);
    if (total <= 1) return;
    var next = (carousel.currentPage + 1) % total;
    var prev = ((carousel.currentPage - 1) % total + total) % total;
    setTimeout(function () {
      ensureIconImagesForPage(next, carousel);
      ensureIconImagesForPage(prev, carousel);
    }, 0);
  }

  function preloadNeighborBgPages(carousel) {
    var total = getTotalPages(carousel);
    if (total <= 1) return;
    var next = (carousel.currentPage + 1) % total;
    var prev = ((carousel.currentPage - 1) % total + total) % total;
    setTimeout(function () {
      ensureBgImagesForPage(next, carousel);
      ensureBgImagesForPage(prev, carousel);
    }, 0);
  }

  function setGridPageVisibility(carousel, page) {
    var start = page * carousel.perPage;
    var end = start + carousel.perPage;
    var allItems = qa(':scope > button', carousel.grid);
    var visIdx = 0;
    allItems.forEach(function (item) {
      if (item.classList.contains('sk-filter-hidden') || item.hasAttribute('data-broken')) {
        item.classList.add('sk-page-hidden');
        return;
      }
      if (visIdx >= start && visIdx < end) {
        item.classList.remove('sk-page-hidden');
      } else {
        item.classList.add('sk-page-hidden');
      }
      visIdx++;
    });
  }

  function shouldStabilizeGridViewport(carousel) {
    var id = carousel.grid && carousel.grid.id;
    return id === 'sk-icon-grid' || id === 'sk-bg-grid';
  }

  /* Keep viewport height = tallest page so short last pages do not shrink the block (no “zoom out”). */
  function recalcGridViewportMinHeightMax(carousel) {
    if (!shouldStabilizeGridViewport(carousel)) return;
    var vp = carousel.grid && carousel.grid.parentElement;
    if (!vp || !vp.classList.contains('sk-grid-viewport')) return;
    var saved = carousel.currentPage;
    var total = getTotalPages(carousel);
    var maxH = 0;
    for (var p = 0; p < total; p++) {
      setGridPageVisibility(carousel, p);
      var h = carousel.grid.offsetHeight;
      if (h > maxH) maxH = h;
    }
    carousel.currentPage = saved;
    vp.style.minHeight = maxH > 0 ? maxH + 'px' : '';
    setGridPageVisibility(carousel, saved);
    renderGridDots(carousel);
    updateGridArrows(carousel);
  }

  function renderGridPage(carousel) {
    setGridPageVisibility(carousel, carousel.currentPage);
    renderGridDots(carousel);
    updateGridArrows(carousel);
  }

  function renderGridDots(carousel) {
    var container = carousel.dotsContainer;
    if (!container) return;

    var total = getTotalPages(carousel);
    container.innerHTML = '';

    if (total <= 1) {
      container.style.display = 'none';
      return;
    }
    container.style.display = '';

    for (var i = 0; i < total; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sk-grid-dot' + (i === carousel.currentPage ? ' sk-active' : '');
      dot.setAttribute('aria-label', 'Seite ' + (i + 1));
      (function (idx) {
        dot.addEventListener('click', function () {
          goGridPage(carousel, idx);
        });
      })(i);
      container.appendChild(dot);
    }
  }

  function updateGridArrows(carousel) {
    var total = getTotalPages(carousel);
    if (carousel.prevBtn) carousel.prevBtn.style.visibility = total <= 1 ? 'hidden' : '';
    if (carousel.nextBtn) carousel.nextBtn.style.visibility = total <= 1 ? 'hidden' : '';
  }

  function recalcGridCarousel(gridId) {
    var carousel = gridCarousels[gridId];
    if (!carousel) return;
    var total = getTotalPages(carousel);
    if (carousel.currentPage >= total) carousel.currentPage = 0;
    if (shouldStabilizeGridViewport(carousel)) {
      var vp = carousel.grid.parentElement;
      if (vp && vp.classList.contains('sk-grid-viewport')) vp.style.minHeight = '';
    }
    renderGridPage(carousel);

    if (gridId === 'sk-icon-grid') {
      ensureIconImagesForPage(carousel.currentPage, carousel);
    }
    if (gridId === 'sk-bg-grid') {
      lazyLoadVisibleBgImages(carousel);
    }
    if (shouldStabilizeGridViewport(carousel)) {
      recalcGridViewportMinHeightMax(carousel);
    }
  }

  function recalcStabilizedGridMinHeightsOnResize() {
    ['sk-icon-grid', 'sk-bg-grid'].forEach(function (id) {
      var c = gridCarousels[id];
      if (!c) return;
      var vp = c.grid && c.grid.parentElement;
      if (vp && vp.classList.contains('sk-grid-viewport')) vp.style.minHeight = '';
      recalcGridViewportMinHeightMax(c);
    });
  }

  function initProductCarousel() {
    var track = q('#sk-carousel-track');
    var viewport = q('#sk-carousel-viewport');
    var slides = qa('.sk-carousel-slide');
    if (!track || !slides.length) return;

    var n = slides.length;
    if (n <= 1) {
      var prevEl = q('#sk-carousel-prev');
      var nextEl = q('#sk-carousel-next');
      var dotsWrap = q('#sk-carousel-dots');
      var thumbsWrap = q('#sk-carousel-thumbs');
      var hintEl = q('.sk-carousel-hint');
      if (prevEl) prevEl.hidden = true;
      if (nextEl) nextEl.hidden = true;
      if (dotsWrap) dotsWrap.hidden = true;
      if (thumbsWrap) thumbsWrap.hidden = true;
      if (hintEl) hintEl.hidden = true;
    }

    var prev = q('#sk-carousel-prev');
    var next = q('#sk-carousel-next');
    var dots = qa('#sk-carousel-dots .sk-carousel-dot');
    var thumbs = qa('#sk-carousel-thumbs .sk-carousel-thumb');
    var i = 0;

    function pauseOtherVideos(activeIdx) {
      slides.forEach(function (slide, j) {
        var v = slide.querySelector('video');
        if (v && j !== activeIdx) {
          try { v.pause(); } catch (e) {}
        }
      });
    }

    function go(idx) {
      i = ((idx % n) + n) % n;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, j) {
        d.classList.toggle('sk-active', j === i);
        d.setAttribute('aria-selected', j === i ? 'true' : 'false');
      });
      thumbs.forEach(function (t, j) {
        t.classList.toggle('sk-active', j === i);
      });
      pauseOtherVideos(i);
    }

    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, j) {
      d.addEventListener('click', function () { go(j); });
    });
    thumbs.forEach(function (t, j) {
      t.addEventListener('click', function () { go(j); });
    });

    var touchStartX = null;
    var touchDragging = false;
    if (viewport) {
      viewport.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
        touchDragging = false;
        track.style.transition = 'none';
      }, { passive: true });

      viewport.addEventListener('touchmove', function (e) {
        if (touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 6) touchDragging = true;
        if (touchDragging) {
          track.style.transform = 'translateX(calc(-' + (i * 100) + '% + ' + dx + 'px))';
        }
      }, { passive: true });

      viewport.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        track.style.transition = '';
        if (touchDragging && Math.abs(dx) >= 45) {
          if (dx > 0) go(i - 1);
          else go(i + 1);
        } else {
          go(i);
        }
        touchDragging = false;
      }, { passive: true });

      viewport.addEventListener('touchcancel', function () {
        if (touchStartX === null) return;
        touchStartX = null;
        touchDragging = false;
        track.style.transition = '';
        go(i);
      }, { passive: true });
    }

    go(0);
  }

  function initIconGrid() {
    var items = qa('.sk-icon-item');
    if (!items.length) return;

    var first = q('.sk-icon-item.sk-selected');
    if (first) {
      state.selectedIcon = { url: first.getAttribute('data-url'), label: first.getAttribute('data-label') };
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        qa('.sk-icon-item.sk-selected').forEach(function (el) { el.classList.remove('sk-selected'); });
        item.classList.add('sk-selected');
        state.selectedIcon = { url: item.getAttribute('data-url'), label: item.getAttribute('data-label') };
        syncProperties();
        updatePreview();
      });
    });
  }

  function initBgGrid() {
    var items = qa('.sk-bg-item');
    if (!items.length) return;

    var first = q('.sk-bg-item.sk-selected');
    if (first) {
      state.selectedBg = { url: first.getAttribute('data-url'), label: first.getAttribute('data-label') };
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        qa('.sk-bg-item.sk-selected').forEach(function (el) { el.classList.remove('sk-selected'); });
        item.classList.add('sk-selected');
        state.selectedBg = { url: item.getAttribute('data-url'), label: item.getAttribute('data-label') };
        syncProperties();
        updatePreview();
      });
    });
  }

  function initFontGrid() {
    var items = qa('.sk-font-item');
    if (!items.length) return;

    var first = q('.sk-font-item.sk-selected');
    if (first) {
      state.selectedFont = {
        family: first.getAttribute('data-font'),
        label: first.getAttribute('data-label'),
        weight: first.getAttribute('data-weight') || '400'
      };
      state.selectedFontWeight = state.selectedFont.weight;
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        qa('.sk-font-item.sk-selected').forEach(function (el) { el.classList.remove('sk-selected'); });
        item.classList.add('sk-selected');
        state.selectedFont = {
          family: item.getAttribute('data-font'),
          label: item.getAttribute('data-label'),
          weight: item.getAttribute('data-weight') || '400'
        };
        state.selectedFontWeight = state.selectedFont.weight;
        syncProperties();
        updatePreview();
      });
    });
  }

  function initColorGrid() {
    var items = qa('.sk-color-item');
    if (!items.length) return;

    var first = q('.sk-color-item.sk-selected');
    if (first) state.selectedColor = first.getAttribute('data-color');

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        qa('.sk-color-item.sk-selected').forEach(function (el) { el.classList.remove('sk-selected'); });
        item.classList.add('sk-selected');
        state.selectedColor = item.getAttribute('data-color');
        syncProperties();
        updatePreview();
      });
    });
  }

  function updateHeroPriceFromCard(card) {
    var priceEl = q('#sk-hero-product-price');
    var currentMoney = priceEl ? priceEl.querySelector('.money') : null;
    var compareWrap = q('#sk-hero-compare-price');
    var compareMoney = compareWrap ? compareWrap.querySelector('.money') : null;
    if (!card || !currentMoney) return;

    var price = parseInt(card.getAttribute('data-variant-price'), 10);
    if (isNaN(price)) return;

    currentMoney.textContent = formatMoney(price);
    if (priceEl) priceEl.setAttribute('content', (price / 100).toFixed(2));

    var compareRaw = card.getAttribute('data-variant-compare-at');
    var compare = parseInt(compareRaw, 10);
    if (isNaN(compare)) compare = 0;

    if (compareWrap && compareMoney && compare > price) {
      compareMoney.textContent = formatMoney(compare);
      compareWrap.classList.remove('hide');
      if (priceEl) priceEl.classList.add('on-sale', 'text-sale');
    } else if (compareWrap && compareMoney) {
      compareWrap.classList.add('hide');
      compareMoney.textContent = '';
      if (priceEl) priceEl.classList.remove('on-sale', 'text-sale');
    }
  }

  function initVariants() {
    var cards = qa('.sk-variant-card');
    var variantSelect = q('#sk-variant-id');
    if (!cards.length || !variantSelect) return;

    var active = q('.sk-variant-card.sk-active');
    if (active) {
      state.selectedVariantId = active.getAttribute('data-variant-id');
      updateHeroPriceFromCard(active);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('.sk-bb-children')) return;

        var vi = parseInt(card.getAttribute('data-variant-index'), 10);
        var wasActive = card.classList.contains('sk-active');

        qa('.sk-variant-card.sk-active').forEach(function (el) {
          el.classList.remove('sk-active');
          el.setAttribute('aria-checked', 'false');
        });
        card.classList.add('sk-active');
        card.setAttribute('aria-checked', 'true');

        var variantId = card.getAttribute('data-variant-id');
        state.selectedVariantId = variantId;
        variantSelect.value = variantId;
        updateHeroPriceFromCard(card);

        if (vi === 2) {
          setTwoChildrenMode(true);
        } else {
          setTwoChildrenMode(false);
        }

        updatePreview();
      });
    });

    if (active) {
      var vi = parseInt(active.getAttribute('data-variant-index'), 10);
      if (vi === 2) setTwoChildrenMode(true);
    }
  }

  /* ----------------------------------------------------------------
     Two-Children Flow
     ---------------------------------------------------------------- */
  function captureDesign() {
    var colorItem = q('.sk-color-item.sk-selected');
    return {
      line1: (q('#sk-line1') || {}).value || '',
      line2: (q('#sk-line2') || {}).value || '',
      motivOn: state.motivOn,
      icon: state.selectedIcon ? { url: state.selectedIcon.url, label: state.selectedIcon.label } : null,
      bg: state.selectedBg ? { url: state.selectedBg.url, label: state.selectedBg.label } : null,
      font: state.selectedFont ? { family: state.selectedFont.family, label: state.selectedFont.label, weight: state.selectedFont.weight } : null,
      color: state.selectedColor,
      colorLabel: colorItem ? colorItem.getAttribute('data-label') : ''
    };
  }

  function restoreDesign(design) {
    if (!design) return;

    var line1Input = q('#sk-line1');
    var line2Input = q('#sk-line2');
    if (line1Input) {
      line1Input.value = design.line1;
      var c1 = q('.sk-count[data-count-for="1"]');
      if (c1) c1.textContent = design.line1.length;
    }
    if (line2Input) {
      line2Input.value = design.line2;
      var c2 = q('.sk-count[data-count-for="2"]');
      if (c2) c2.textContent = design.line2.length;
    }

    var motivToggle = q('#sk-motiv-toggle');
    if (motivToggle && motivToggle.checked !== design.motivOn) {
      motivToggle.checked = design.motivOn;
      motivToggle.dispatchEvent(new Event('change'));
    }

    if (design.icon) {
      var iconItem = q('.sk-icon-item[data-url="' + design.icon.url + '"]');
      if (iconItem && !iconItem.classList.contains('sk-selected')) {
        qa('.sk-icon-item.sk-selected').forEach(function (el) { el.classList.remove('sk-selected'); });
        iconItem.classList.add('sk-selected');
        state.selectedIcon = { url: design.icon.url, label: design.icon.label };
      }
    }

    if (design.bg) {
      var bgItem = q('.sk-bg-item[data-url="' + design.bg.url + '"]');
      if (bgItem && !bgItem.classList.contains('sk-selected')) {
        qa('.sk-bg-item.sk-selected').forEach(function (el) { el.classList.remove('sk-selected'); });
        bgItem.classList.add('sk-selected');
        state.selectedBg = { url: design.bg.url, label: design.bg.label };
      }
    }

    if (design.font) {
      var fontItem = q('.sk-font-item[data-font="' + design.font.family + '"]');
      if (fontItem && !fontItem.classList.contains('sk-selected')) {
        qa('.sk-font-item.sk-selected').forEach(function (el) { el.classList.remove('sk-selected'); });
        fontItem.classList.add('sk-selected');
        state.selectedFont = { family: design.font.family, label: design.font.label, weight: design.font.weight };
        state.selectedFontWeight = design.font.weight;
      }
    }

    if (design.color) {
      var colorItem = q('.sk-color-item[data-color="' + design.color + '"]');
      if (colorItem && !colorItem.classList.contains('sk-selected')) {
        qa('.sk-color-item.sk-selected').forEach(function (el) { el.classList.remove('sk-selected'); });
        colorItem.classList.add('sk-selected');
        state.selectedColor = design.color;
      }
    }

    syncProperties();
    updatePreview();
  }

  function buildStickerEl(design) {
    var el = document.createElement('div');
    el.className = 'sk-sticker';
    if (design.bg) el.style.backgroundImage = "url('" + design.bg.url + "')";

    if (design.motivOn && design.icon) {
      var img = document.createElement('img');
      img.className = 'sk-sticker-icon';
      img.src = design.icon.url;
      img.alt = '';
      el.appendChild(img);
    }

    var linesWrap = document.createElement('div');
    linesWrap.className = 'sk-sticker-lines' + (!design.line2 ? ' sk-single-line' : '');

    var span1 = document.createElement('span');
    span1.className = 'sk-sticker-line sk-sticker-line1';
    span1.textContent = design.line1 || 'Name';
    if (design.font) {
      span1.style.fontFamily = design.font.family;
      span1.style.fontWeight = design.font.weight;
    }
    if (design.color) span1.style.color = design.color;
    linesWrap.appendChild(span1);

    if (design.line2) {
      var span2 = document.createElement('span');
      span2.className = 'sk-sticker-line sk-sticker-line2';
      span2.textContent = design.line2;
      if (design.font) {
        span2.style.fontFamily = design.font.family;
        span2.style.fontWeight = design.font.weight;
      }
      if (design.color) span2.style.color = design.color;
      linesWrap.appendChild(span2);
    }

    el.appendChild(linesWrap);
    return el;
  }

  function fitBuiltSticker(el) {
    var linesWrap = el.querySelector('.sk-sticker-lines');
    var line1 = el.querySelector('.sk-sticker-line1');
    var line2 = el.querySelector('.sk-sticker-line2');
    if (!linesWrap || !line1) return;

    var availW = linesWrap.clientWidth - 8;
    var availH = el.clientHeight - 16;
    if (availW < 20 || availH < 20) return;

    var hasLine2 = line2 && line2.textContent.trim();
    var minPx = 12;
    var maxCap = 120;
    var lhFactor = 1.15;

    function bestFit(textEl, maxPx) {
      if (maxPx < minPx) maxPx = minPx;
      textEl.style.width = 'max-content';
      textEl.style.maxWidth = 'none';
      var lo = minPx, hi = maxPx, best = minPx;
      while (lo <= hi) {
        var mid = (lo + hi) >> 1;
        textEl.style.fontSize = mid + 'px';
        if (textEl.getBoundingClientRect().width <= availW + 0.5) { best = mid; lo = mid + 1; }
        else { hi = mid - 1; }
      }
      textEl.style.fontSize = best + 'px';
      textEl.style.width = '';
      textEl.style.maxWidth = '';
    }

    if (!hasLine2) {
      bestFit(line1, Math.min(Math.floor(availH / lhFactor), maxCap));
    } else {
      var maxPx = Math.min(Math.floor((availH - 2) / (2 * lhFactor)), maxCap);
      bestFit(line1, maxPx);
      if (line2) bestFit(line2, maxPx);
    }
  }

  function buildMiniSticker(design) {
    if (!design) return null;
    var frag = document.createDocumentFragment();

    var stdItem = document.createElement('div');
    stdItem.className = 'sk-bb-scope-item';
    var stdWrap = document.createElement('div');
    stdWrap.className = 'sk-sticker-clone-wrap';
    var stickerEl = buildStickerEl(design);
    stdWrap.appendChild(stickerEl);
    stdItem.appendChild(stdWrap);
    var stdLabel = document.createElement('span');
    stdLabel.className = 'sk-bb-scope-label';
    stdLabel.textContent = '150x Sticker';
    stdItem.appendChild(stdLabel);
    frag.appendChild(stdItem);

    var penItem = document.createElement('div');
    penItem.className = 'sk-bb-scope-item';
    var pen = buildPenEl(design);
    penItem.appendChild(pen);
    var penLabel = document.createElement('span');
    penLabel.className = 'sk-bb-scope-label';
    penLabel.textContent = '50x Stift Sticker';
    penItem.appendChild(penLabel);
    frag.appendChild(penItem);

    requestAnimationFrame(function () {
      fitBuiltSticker(stickerEl);
      scaleCloneInWrap(stdWrap, stickerEl);
      var penText = pen.querySelector('.sk-bb-pen-text');
      if (penText) fitPenText(pen, penText);
    });

    return frag;
  }

  function updateMiniPreview(childNum, design) {
    var container = q('#sk-bb-preview-' + childNum);
    if (!container) return;

    container.innerHTML = '';
    container.classList.remove('sk-bb-mini--empty');

    if (!design) {
      container.classList.add('sk-bb-mini--empty');
      var cta = document.createElement('span');
      cta.className = 'sk-bb-mini-cta';
      cta.textContent = 'Klicken um zu konfigurieren';
      container.appendChild(cta);
      return;
    }

    var frag = buildMiniSticker(design);
    if (frag) container.appendChild(frag);
  }

  function updateMiniPreviewLive() {
    if (!twoChildren.active) return;
    var container = q('#sk-bb-preview-' + twoChildren.editingChild);
    var sticker = q('#sk-sticker');
    if (!container || !sticker) return;

    container.innerHTML = '';
    container.classList.remove('sk-bb-mini--empty');

    var frag = document.createDocumentFragment();

    var stdItem = document.createElement('div');
    stdItem.className = 'sk-bb-scope-item';
    var stdWrap = document.createElement('div');
    stdWrap.className = 'sk-sticker-clone-wrap';
    var clone = sticker.cloneNode(true);
    clone.removeAttribute('id');
    qa('[id]', clone).forEach(function (el) { el.removeAttribute('id'); });
    stdWrap.appendChild(clone);
    stdItem.appendChild(stdWrap);
    var stdLabel = document.createElement('span');
    stdLabel.className = 'sk-bb-scope-label';
    stdLabel.textContent = '150x Sticker';
    stdItem.appendChild(stdLabel);
    frag.appendChild(stdItem);

    var penItem = document.createElement('div');
    penItem.className = 'sk-bb-scope-item';
    var design = captureDesign();
    var pen = buildPenEl(design);
    penItem.appendChild(pen);
    var penLabel = document.createElement('span');
    penLabel.className = 'sk-bb-scope-label';
    penLabel.textContent = '50x Stift Sticker';
    penItem.appendChild(penLabel);
    frag.appendChild(penItem);

    container.appendChild(frag);

    requestAnimationFrame(function () {
      scaleCloneInWrap(stdWrap, clone);
      var penText = pen.querySelector('.sk-bb-pen-text');
      if (penText) fitPenText(pen, penText);
    });
  }

  function updateAtcState() {
    var atcBtn = q('#sk-atc');
    var hint = q('#sk-bb-save-hint');
    if (!atcBtn) return;

    if (twoChildren.active) {
      if (twoChildren.child2Visited) {
        atcBtn.classList.remove('sk-atc-disabled');
        atcBtn.removeAttribute('title');
        if (hint) hint.style.display = '';
      } else {
        atcBtn.classList.add('sk-atc-disabled');
        atcBtn.setAttribute('title', 'Bitte konfiguriere beide Designs');
        if (hint) hint.style.display = 'none';
      }
    } else {
      atcBtn.classList.remove('sk-atc-disabled');
      atcBtn.removeAttribute('title');
      if (hint) hint.style.display = 'none';
    }
  }

  function switchChild(target) {
    if (target === twoChildren.editingChild) return;

    twoChildren.designs[twoChildren.editingChild] = captureDesign();
    updateMiniPreview(twoChildren.editingChild, twoChildren.designs[twoChildren.editingChild]);
    syncChildProperties();

    var slot1 = q('#sk-bb-child-1');
    var slot2 = q('#sk-bb-child-2');

    if (target === 1) {
      if (slot1) { slot1.classList.add('sk-bb-child--editing'); slot1.classList.remove('sk-bb-child--saved'); }
      if (slot2) { slot2.classList.remove('sk-bb-child--editing'); slot2.classList.add('sk-bb-child--saved'); }
    } else {
      if (slot2) { slot2.classList.add('sk-bb-child--editing'); slot2.classList.remove('sk-bb-child--saved'); }
      if (slot1) { slot1.classList.remove('sk-bb-child--editing'); slot1.classList.add('sk-bb-child--saved'); }
    }

    twoChildren.editingChild = target;
    if (target === 2) twoChildren.child2Visited = true;

    if (twoChildren.designs[target]) {
      restoreDesign(twoChildren.designs[target]);
    } else {
      var line1 = q('#sk-line1');
      var line2 = q('#sk-line2');
      if (line1) { line1.value = ''; var c1 = q('.sk-count[data-count-for="1"]'); if (c1) c1.textContent = '0'; }
      if (line2) { line2.value = ''; var c2 = q('.sk-count[data-count-for="2"]'); if (c2) c2.textContent = '0'; }
      syncProperties();
      updatePreview();
    }

    updateAtcState();

    var isMobile = window.matchMedia('(max-width: 999px)').matches;
    if (isMobile) {
      var konfig = q('#sticker-konfigurator');
      if (konfig) konfig.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function setTwoChildrenMode(active) {
    if (twoChildren.active === active) return;

    var stdInputs = ['sk-prop-line1', 'sk-prop-line2', 'sk-prop-motiv', 'sk-prop-bg', 'sk-prop-font', 'sk-prop-color'];
    var k1Inputs = ['sk-prop-line1-k1', 'sk-prop-line2-k1', 'sk-prop-motiv-k1', 'sk-prop-bg-k1', 'sk-prop-font-k1', 'sk-prop-color-k1'];
    var k2Inputs = ['sk-prop-line1-k2', 'sk-prop-line2-k2', 'sk-prop-motiv-k2', 'sk-prop-bg-k2', 'sk-prop-font-k2', 'sk-prop-color-k2'];

    if (active) {
      twoChildren.active = true;
      twoChildren.editingChild = 1;
      twoChildren.child2Visited = false;
      twoChildren.designs[1] = captureDesign();
      twoChildren.designs[2] = null;

      stdInputs.forEach(function (id) { var el = q('#' + id); if (el) el.disabled = true; });
      k1Inputs.forEach(function (id) { var el = q('#' + id); if (el) el.disabled = false; });
      k2Inputs.forEach(function (id) { var el = q('#' + id); if (el) el.disabled = false; });

      updateMiniPreview(1, twoChildren.designs[1]);
      updateMiniPreview(2, null);

      var slot1 = q('#sk-bb-child-1');
      var slot2 = q('#sk-bb-child-2');
      if (slot1) { slot1.classList.add('sk-bb-child--editing'); slot1.classList.remove('sk-bb-child--saved'); }
      if (slot2) { slot2.classList.remove('sk-bb-child--editing', 'sk-bb-child--saved'); }

      updateAtcState();
      syncChildProperties();
    } else {
      if (twoChildren.active && twoChildren.editingChild !== 1 && twoChildren.designs[1]) {
        restoreDesign(twoChildren.designs[1]);
      }

      twoChildren.active = false;

      stdInputs.forEach(function (id) { var el = q('#' + id); if (el) el.disabled = false; });
      k1Inputs.forEach(function (id) { var el = q('#' + id); if (el) el.disabled = true; });
      k2Inputs.forEach(function (id) { var el = q('#' + id); if (el) el.disabled = true; });

      updateAtcState();
      syncProperties();
    }
  }

  function syncChildProperties() {
    if (!twoChildren.active) return;

    var d1 = twoChildren.designs[1];
    if (d1) {
      var p = function (id, val) { var el = q('#' + id); if (el) el.value = val || ''; };
      p('sk-prop-line1-k1', d1.line1);
      p('sk-prop-line2-k1', d1.line2);
      p('sk-prop-motiv-k1', d1.motivOn && d1.icon ? d1.icon.label : 'Kein Motiv');
      p('sk-prop-bg-k1', d1.bg ? d1.bg.label : '');
      p('sk-prop-font-k1', d1.font ? d1.font.label : '');
      p('sk-prop-color-k1', d1.colorLabel || '');
    }

    var d2 = twoChildren.designs[2];
    if (d2) {
      var p2 = function (id, val) { var el = q('#' + id); if (el) el.value = val || ''; };
      p2('sk-prop-line1-k2', d2.line1);
      p2('sk-prop-line2-k2', d2.line2);
      p2('sk-prop-motiv-k2', d2.motivOn && d2.icon ? d2.icon.label : 'Kein Motiv');
      p2('sk-prop-bg-k2', d2.bg ? d2.bg.label : '');
      p2('sk-prop-font-k2', d2.font ? d2.font.label : '');
      p2('sk-prop-color-k2', d2.colorLabel || '');
    }
  }

  function initTwoChildren() {
    var slot1 = q('#sk-bb-child-1');
    var slot2 = q('#sk-bb-child-2');

    if (slot1) {
      slot1.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!twoChildren.active) return;
        switchChild(1);
      });
    }

    if (slot2) {
      slot2.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!twoChildren.active) return;
        switchChild(2);
      });
    }
  }

  function initQuantity() {
    var input = q('#sk-qty');
    var minus = q('#sk-qty-minus');
    var plus = q('#sk-qty-plus');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }

  function initFormValidation() {
    var form = q('#sk-product-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var line1 = q('#sk-line1');

      if (twoChildren.active) {
        twoChildren.designs[twoChildren.editingChild] = captureDesign();

        if (!twoChildren.child2Visited) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var childrenWrap = q('#sk-bb-children');
          if (childrenWrap) childrenWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        syncChildProperties();
        return;
      }

      if (!line1 || line1.value.trim()) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      line1.classList.add('sk-error');
      var msg = q('#sk-error-msg');
      if (msg) msg.classList.add('sk-visible');
      line1.focus();
      line1.scrollIntoView({ behavior: 'smooth', block: 'center' });

      setTimeout(function () {
        line1.classList.remove('sk-error');
      }, 2000);
    }, true);
  }

  function categoryPrefixBeforeMarker(name, markerWithDashes) {
    if (!name || !markerWithDashes) return '';
    var lower = name.toLowerCase();
    var m = markerWithDashes.toLowerCase();
    var i = lower.indexOf(m);
    if (i <= 0) return '';
    return name.substring(0, i).replace(/-+$/, '') || '';
  }

  function assignCategoriesFromNames() {
    qa('.sk-icon-item').forEach(function (item) {
      var n = item.getAttribute('data-name') || '';
      var cat = categoryPrefixBeforeMarker(n, '-icon');
      if (cat) item.setAttribute('data-category', cat);
    });
    qa('.sk-bg-item').forEach(function (item) {
      var n = item.getAttribute('data-name') || '';
      var cat = categoryPrefixBeforeMarker(n, '-background');
      if (cat) item.setAttribute('data-category', cat);
    });
  }

  function initFilters() {
    assignCategoriesFromNames();
    buildFilterOptions('#sk-motiv-filter', '.sk-icon-item');
    buildFilterOptions('#sk-bg-filter', '.sk-bg-item');

    var motivFilter = q('#sk-motiv-filter');
    var bgFilter = q('#sk-bg-filter');

    if (motivFilter) motivFilter.addEventListener('change', function () {
      filterItems('.sk-icon-item', this.value);
      renderedIconPages = {};
      recalcGridCarousel('sk-icon-grid');
      ensureVisibleSelection('.sk-icon-item');
    });
    if (bgFilter) bgFilter.addEventListener('change', function () {
      filterItems('.sk-bg-item', this.value);
      recalcGridCarousel('sk-bg-grid');
      ensureVisibleSelection('.sk-bg-item');
    });
  }

  function buildFilterOptions(selectSel, itemSel) {
    var select = q(selectSel);
    var items = qa(itemSel);
    if (!select || !items.length) return;

    while (select.options.length > 1) {
      select.remove(1);
    }

    var cats = [];
    var seen = {};
    items.forEach(function (item) {
      var cat = (item.getAttribute('data-category') || '').trim();
      if (cat && !seen[cat]) {
        seen[cat] = true;
        cats.push(cat);
      }
    });
    cats.sort(function (a, b) { return a.localeCompare(b, 'de'); });
    cats.forEach(function (cat) {
      var opt = document.createElement('option');
      opt.value = cat;
      opt.textContent = cat;
      select.appendChild(opt);
    });
  }

  function filterItems(itemSel, category) {
    qa(itemSel).forEach(function (item) {
      var cat = item.getAttribute('data-category') || '';
      if (category === 'all' || cat === category) {
        item.classList.remove('sk-filter-hidden');
      } else {
        item.classList.add('sk-filter-hidden');
      }
    });
  }

  function ensureVisibleSelection(itemSel) {
    var selected = q(itemSel + '.sk-selected');
    if (selected && !selected.classList.contains('sk-filter-hidden') && !selected.hasAttribute('data-broken')) return;

    var firstVis = null;
    qa(itemSel).forEach(function (el) {
      if (!firstVis && !el.classList.contains('sk-filter-hidden') && !el.hasAttribute('data-broken')) firstVis = el;
    });
    if (firstVis) firstVis.click();
  }

  /* ----------------------------------------------------------------
     Lazy-load remaining Google Fonts (called when Text accordion opens)
     ---------------------------------------------------------------- */
  var _extraFontsLoaded = false;
  function loadExtraFonts() {
    if (_extraFontsLoaded) return;
    _extraFontsLoaded = true;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@800&family=Dancing+Script:wght@700&family=Alfa+Slab+One&family=Caveat:wght@700&family=Open+Sans:wght@400&family=Pacifico&family=Playfair+Display:wght@400&display=swap';
    document.head.appendChild(link);
  }

  /* ----------------------------------------------------------------
     Accordion – collapsible sections
     ---------------------------------------------------------------- */
  function initAccordions() {
    qa('.sk-accordion-header').forEach(function (header) {
      header.addEventListener('click', function () {
        var block = header.closest('.sk-section-block');
        if (!block) return;
        var isCollapsed = block.classList.contains('sk-collapsed');
        block.classList.toggle('sk-collapsed');
        header.setAttribute('aria-expanded', isCollapsed ? 'true' : 'false');

        if (isCollapsed) {
          if (block.id === 'sk-section-text') loadExtraFonts();
          var grids = qa('[data-cols]', block);
          grids.forEach(function (grid) {
            if (grid.id) recalcGridCarousel(grid.id);
          });
        }
      });
    });
  }

  /* ----------------------------------------------------------------
     Responsive Preview – move preview under title on mobile
     ---------------------------------------------------------------- */
  var _lastMobileState = null;

  function handleResponsivePreview() {
    var preview = q('.sk-preview-container');
    var skLeft = q('.sk-left');
    var skRight = q('.sk-right');
    if (!preview || !skLeft || !skRight) return;

    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (isMobile === _lastMobileState) return;
    _lastMobileState = isMobile;

    if (isMobile) {
      var mobileSlot = document.getElementById('sk-mobile-preview-slot');
      if (mobileSlot && mobileSlot.parentNode) {
        mobileSlot.parentNode.insertBefore(preview, mobileSlot);
      }
    } else {
      skRight.insertBefore(preview, skRight.firstChild);
    }
  }

  function initStickyStop() {
    var carousel = q('#sk-media-carousel');
    var preview = q('.sk-preview-container');
    if (!carousel || !preview) return;

    var mobileQuery = window.matchMedia('(max-width: 999px)');
    var parked = false;
    var spacer = null;

    function unpark() {
      preview.style.position = '';
      preview.style.top = '';
      preview.style.left = '';
      preview.style.right = '';
      preview.style.zIndex = '';
      if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
      spacer = null;
      parked = false;
    }

    function checkSticky() {
      if (!mobileQuery.matches) { if (parked) unpark(); return; }

      var parent = preview.parentElement;
      if (!parent) return;

      if (!parked) {
        var carouselRect = carousel.getBoundingClientRect();
        var previewRect = preview.getBoundingClientRect();

        if (previewRect.bottom >= carouselRect.top - 10) {
          var parentRect = parent.getBoundingClientRect();
          var parkTop = previewRect.top - parentRect.top;
          var previewH = previewRect.height;

          spacer = document.createElement('div');
          spacer.style.height = previewH + 'px';
          spacer.style.flexShrink = '0';
          parent.insertBefore(spacer, preview);

          preview.style.position = 'absolute';
          preview.style.top = parkTop + 'px';
          preview.style.left = '0';
          preview.style.right = '0';
          preview.style.zIndex = '10';
          parked = true;
        }
      } else {
        var parentRect = parent.getBoundingClientRect();
        var parkTop = parseFloat(preview.style.top) || 0;
        var parkedViewportTop = parentRect.top + parkTop;

        var stickyTop = parseFloat(getComputedStyle(document.getElementById('sticker-konfigurator')).getPropertyValue('--sk-sticky-top')) || 12;
        if (stickyTop < parkedViewportTop) {
          unpark();
        }
      }
    }

    window.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();
  }

  function syncProperties() {
    if (twoChildren.active) {
      var suffix = twoChildren.editingChild === 1 ? '-k1' : '-k2';
      var pL1 = q('#sk-prop-line1' + suffix);
      var pL2 = q('#sk-prop-line2' + suffix);
      var pM = q('#sk-prop-motiv' + suffix);
      var pB = q('#sk-prop-bg' + suffix);
      var pF = q('#sk-prop-font' + suffix);
      var pC = q('#sk-prop-color' + suffix);

      if (pL1) pL1.value = (q('#sk-line1') || {}).value || '';
      if (pL2) pL2.value = (q('#sk-line2') || {}).value || '';
      if (pM) pM.value = state.motivOn && state.selectedIcon ? state.selectedIcon.label : 'Kein Motiv';
      if (pB && state.selectedBg) pB.value = state.selectedBg.label;
      if (pF && state.selectedFont) pF.value = state.selectedFont.label;
      if (pC) {
        var ci = q('.sk-color-item.sk-selected');
        pC.value = ci ? ci.getAttribute('data-label') : '';
      }
      return;
    }

    var propLine1 = q('#sk-prop-line1');
    var propLine2 = q('#sk-prop-line2');
    var propMotiv = q('#sk-prop-motiv');
    var propBg = q('#sk-prop-bg');
    var propFont = q('#sk-prop-font');
    var propColor = q('#sk-prop-color');

    if (propLine1) propLine1.value = (q('#sk-line1') || {}).value || '';
    if (propLine2) propLine2.value = (q('#sk-line2') || {}).value || '';

    if (propMotiv) {
      propMotiv.value = state.motivOn && state.selectedIcon ? state.selectedIcon.label : 'Kein Motiv';
    }
    if (propBg && state.selectedBg) propBg.value = state.selectedBg.label;
    if (propFont && state.selectedFont) propFont.value = state.selectedFont.label;

    if (propColor) {
      var colorItem = q('.sk-color-item.sk-selected');
      propColor.value = colorItem ? colorItem.getAttribute('data-label') : '';
    }
  }

  var _fitRafId = null;

  function fitStickerPreviewText(hasLine2) {
    var sticker = q('#sk-sticker');
    var linesWrap = q('.sk-sticker-lines');
    var line1 = q('#sk-sticker-line1');
    var line2 = q('#sk-sticker-line2');
    if (!sticker || !linesWrap || !line1) return;

    var availW = linesWrap.clientWidth - 8;
    var availH = sticker.clientHeight - 16;
    if (availW < 20 || availH < 20) return;

    var minPx = 12;
    var maxCap = 120;
    var lhFactor = 1.15;

    function bestFitForEl(el, maxPx) {
      if (maxPx < minPx) maxPx = minPx;
      el.style.transition = 'none';
      el.style.width = 'max-content';
      el.style.maxWidth = 'none';

      var lo = minPx, hi = maxPx, best = minPx;
      while (lo <= hi) {
        var mid = (lo + hi) >> 1;
        el.style.fontSize = mid + 'px';
        if (el.getBoundingClientRect().width <= availW + 0.5) { best = mid; lo = mid + 1; }
        else { hi = mid - 1; }
      }

      el.style.fontSize = best + 'px';
      el.style.width = '';
      el.style.maxWidth = '';
      void el.offsetWidth;
      el.style.transition = '';
      return best;
    }

    if (!hasLine2) {
      var maxByH = Math.floor(availH / lhFactor);
      bestFitForEl(line1, Math.min(maxByH, maxCap));
      if (line2) line2.style.fontSize = '';
    } else {
      var perLineMaxH = Math.floor((availH - 2) / (2 * lhFactor));
      var maxPx = Math.min(perLineMaxH, maxCap);

      bestFitForEl(line1, maxPx);

      if (line2 && !line2.classList.contains('sk-line2-empty')) {
        bestFitForEl(line2, maxPx);
      } else if (line2) {
        line2.style.fontSize = '';
      }
    }
  }

  function updatePreview() {
    var sticker = q('#sk-sticker');
    var icon = q('#sk-sticker-icon');
    var line1 = q('#sk-sticker-line1');
    var line2 = q('#sk-sticker-line2');

    if (sticker && state.selectedBg) {
      sticker.style.backgroundImage = "url('" + state.selectedBg.url + "')";
    }

    if (icon) {
      if (state.motivOn && state.selectedIcon) {
        icon.src = state.selectedIcon.url;
        icon.classList.remove('sk-hidden');
      } else {
        icon.classList.add('sk-hidden');
      }
    }

    var text1 = (q('#sk-line1') || {}).value || '';
    var text2 = ((q('#sk-line2') || {}).value || '').trim();
    var linesWrap = q('.sk-sticker-lines');

    if (line1) line1.textContent = text1 || 'Name';
    if (line2) {
      line2.textContent = text2;
      line2.classList.toggle('sk-line2-empty', !text2);
    }

    if (linesWrap) {
      linesWrap.classList.toggle('sk-single-line', !text2);
    }

    var fontFamily = state.selectedFont ? state.selectedFont.family : "'Nunito', sans-serif";
    var fontWeight = state.selectedFontWeight || '800';
    var color = state.selectedColor || '#000000';

    [line1, line2].forEach(function (el) {
      if (!el) return;
      el.style.fontFamily = fontFamily;
      el.style.fontWeight = fontWeight;
      el.style.color = color;
    });

    fitStickerPreviewText(!!text2);
    if (_fitRafId !== null) cancelAnimationFrame(_fitRafId);
    _fitRafId = requestAnimationFrame(function () {
      _fitRafId = null;
      fitStickerPreviewText(!!text2);
    });

    updateMiniPreviewLive();
    updateBuyboxScopePreviews();
  }

  function scaleCloneInWrap(wrap, stickerEl) {
    var cw = wrap.clientWidth;
    var w = stickerEl.offsetWidth;
    var h = stickerEl.offsetHeight;
    if (w > 0 && cw > 0) {
      var scale = cw / w;
      wrap.style.width = cw + 'px';
      wrap.style.height = Math.round(h * scale) + 'px';
      stickerEl.style.position = 'absolute';
      stickerEl.style.top = '0';
      stickerEl.style.left = '0';
      stickerEl.style.transformOrigin = 'top left';
      stickerEl.style.transform = 'scale(' + scale + ')';
    }
  }

  function buildPenEl(design) {
    var pen = document.createElement('div');
    pen.className = 'sk-bb-pen-sticker';
    if (design.bg) pen.style.backgroundImage = "url('" + design.bg.url + "')";

    if (design.motivOn && design.icon) {
      var pImg = document.createElement('img');
      pImg.src = design.icon.url;
      pImg.alt = '';
      pen.appendChild(pImg);
    }

    var pSpan = document.createElement('span');
    pSpan.className = 'sk-bb-pen-text';
    var combined = design.line1 || 'Name';
    if (design.line2) combined += ' ' + design.line2;
    pSpan.textContent = combined;
    if (design.font) {
      pSpan.style.fontFamily = design.font.family;
      pSpan.style.fontWeight = design.font.weight;
    }
    if (design.color) pSpan.style.color = design.color;
    pen.appendChild(pSpan);

    return pen;
  }

  function updateBuyboxScopePreviews() {
    var stdWrap = q('#sk-bb-live-std');
    var penEl = q('#sk-bb-live-pen');
    var sticker = q('#sk-sticker');
    if ((!stdWrap && !penEl) || !sticker) return;

    if (stdWrap) {
      stdWrap.innerHTML = '';
      var clone = sticker.cloneNode(true);
      clone.removeAttribute('id');
      qa('[id]', clone).forEach(function (el) { el.removeAttribute('id'); });
      stdWrap.appendChild(clone);

      requestAnimationFrame(function () {
        scaleCloneInWrap(stdWrap, clone);
      });
    }

    if (penEl) {
      penEl.innerHTML = '';
      var text1 = (q('#sk-line1') || {}).value || '';
      var text2 = ((q('#sk-line2') || {}).value || '').trim();
      var fontFamily = state.selectedFont ? state.selectedFont.family : "'Nunito', sans-serif";
      var fontWeight = state.selectedFontWeight || '800';
      var color = state.selectedColor || '#000000';

      if (state.selectedBg) penEl.style.backgroundImage = "url('" + state.selectedBg.url + "')";

      if (state.motivOn && state.selectedIcon) {
        var pImg = document.createElement('img');
        pImg.src = state.selectedIcon.url;
        pImg.alt = '';
        penEl.appendChild(pImg);
      }

      var pSpan = document.createElement('span');
      pSpan.className = 'sk-bb-pen-text';
      var combined = (text1 || 'Name');
      if (text2) combined += ' ' + text2;
      pSpan.textContent = combined;
      pSpan.style.fontFamily = fontFamily;
      pSpan.style.fontWeight = fontWeight;
      pSpan.style.color = color;
      penEl.appendChild(pSpan);

      fitPenText(penEl, pSpan);
    }
  }

  function fitPenText(container, textEl) {
    if (!container || !textEl) return;
    var h = container.clientHeight;
    if (h < 8) return;
    var targetSize = Math.max(8, Math.floor(h * 0.7));
    textEl.style.fontSize = targetSize + 'px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
